var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 9.08999C11.2767 9.08999 10.583 9.37733 10.0715 9.88879C9.56006 10.4003 9.27273 11.0939 9.27273 11.8173C9.27273 12.5406 9.56006 13.2343 10.0715 13.7457C10.583 14.2572 11.2767 14.5445 12 14.5445C12.7233 14.5445 13.417 14.2572 13.9285 13.7457C14.4399 13.2343 14.7273 12.5406 14.7273 11.8173C14.7273 11.0939 14.4399 10.4003 13.9285 9.88879C13.417 9.37733 12.7233 9.08999 12 9.08999ZM12 16.3627C10.7945 16.3627 9.63832 15.8838 8.78588 15.0314C7.93344 14.179 7.45455 13.0228 7.45455 11.8173C7.45455 10.6117 7.93344 9.45558 8.78588 8.60314C9.63832 7.75071 10.7945 7.27181 12 7.27181C13.2055 7.27181 14.3617 7.75071 15.2141 8.60314C16.0666 9.45558 16.5455 10.6117 16.5455 11.8173C16.5455 13.0228 16.0666 14.179 15.2141 15.0314C14.3617 15.8838 13.2055 16.3627 12 16.3627ZM12 4.99908C7.58182 4.99908 3.61818 7.72636 2 11.8173C4.17273 17.3445 10.4091 20.0536 15.9364 17.8809C18.7091 16.79 20.9091 14.5991 22 11.8173C20.3818 7.72636 16.4182 4.99908 12 4.99908Z",
  fill: "#006FFD"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_803_7156)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#00538F"
}));

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_803_7156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 20,
    height: 15
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d799498c.svg";
export { ForwardRef as ReactComponent };